import AwinParams from "@store/checkout/interfaces/awinParams";
import GtmParams from "@store/checkout/interfaces/gtmParams";
import { initialState } from "@store/checkout";
import Cookies from "js-cookie";

const AWIN_CUSTOM_COOKIE = '_awin_data';
const SESSION_ID = 'session_id';
const USER_ID = 'user_id';
const CLIENT_ID = 'client_id';
const TRAVELAGENCY_ID = 'travelagency';

export function getAWINCustomCookie (): AwinParams {
    const cookieValue: string = getCookieByIdentifier(AWIN_CUSTOM_COOKIE);

    return cookieValue ? JSON.parse(cookieValue) : initialState.checkoutSummary.tracking.awin;
}

export function getGTMCookie (): GtmParams {
    return {
        sessionId: getCookieByIdentifier(SESSION_ID),
        userId: getCookieByIdentifier(USER_ID),
        clientId: getCookieByIdentifier(CLIENT_ID)
    };
}

export function getTravelagencyCookie (): string {
    const cookieValue: string = getCookieByIdentifier(TRAVELAGENCY_ID);

    return cookieValue ? cookieValue.replace(/^(.*)=/, '') : '';
}

function getCookieByIdentifier(identifier: string): string {
    const cookieValue = Cookies.get(identifier);

    return cookieValue !== undefined ? cookieValue : '';
}
